import { Dialog, DialogContent, Divider, List } from '@mui/material';
import * as React from 'react';
import { useTranslation } from 'react-i18next';

import { SolaForceDialogTitle } from '~/components/SolaForceDialogTitle';
import { People } from '~/services/Http';

import { Announcement } from '../Announcement';

import { useSxStyles } from './useStyles';

export interface Props {
  announcements: People.CompanyPostDto[];
  open: boolean;
  onClose: () => void;
}

export const AllAnnouncementsDialog: React.FC<Props> = ({
  announcements,
  open,
  onClose,
}) => {
  const sxStyles = useSxStyles();
  const { t } = useTranslation();

  return (
    <Dialog
      open={open}
      onClose={onClose}
      data-cy="all-announcements-widget-dialog"
    >
      <SolaForceDialogTitle onClose={onClose}>
        {t('announcements')}
      </SolaForceDialogTitle>
      <DialogContent sx={sxStyles.dialogContent}>
        <List disablePadding={true} data-cy="list">
          {announcements.map((announcement, index) => (
            <div key={announcement.id}>
              <Announcement announcement={announcement} />
              {index < announcements.length - 1 && (
                <Divider sx={sxStyles.divider} />
              )}
            </div>
          ))}
        </List>
      </DialogContent>
    </Dialog>
  );
};
